import { computed } from "vue";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { ComboboxEmptyProps } from "./combobox.types";
import { comboboxEmptyClasses } from "./combobox.styles";
import { useCombobox } from "./useCombobox";

export interface UseComboboxEmptyOptions {
  props: Readonly<ComboboxEmptyProps>;
}

export const useComboboxEmpty = (options: UseComboboxEmptyOptions) => {
  const { props } = options;
  const combobox = useCombobox();
  const classes = computed(() => mergeClassProp(comboboxEmptyClasses({}), props.class));
  const isVisible = computed(() => !combobox.hasFilteredItems.value && combobox.searchTerm.value.length > 0);
  return { classes, isVisible };
};
